<template>
  <div class="container">
    <div style="background-color: white; padding: 20px;">
      <h2 style="color: black;">🐾 The Art of Risk: Your Financial Personality Unleashed with RiskyPaws </h2>
   
        <p style="color: black;">Welcome to RiskyPaws: Where 'Meow' Meets Money Matters 🐱‍👤💰 </p>
  
        At RiskyPaws, we believe in the power of personal choice and self-awareness in navigating the complexities of risk. Just as our feline friends exhibit unique personalities, from the cautious observer to the adventurous explorer, each person carries their distinct approach to financial risk. It's about understanding your inner 'cat' - are you a daring explorer in the world of investments or a cautious guardian of your nest egg?
<br>
        <br>Meet Our Feline Financial Gurus: Masters of Risk Management<br>
        <br>Let's introduce our team of whiskered wisdom-bringers, each embodying a unique perspective on risk, much like the diverse characters we encounter in our financial journeys. These cats aren't just cute; they're the epitome of financial savvy, each with a tale to tell and wisdom to share.  As you go through your financial journey from saving to budgeting and investing each one of our feline finance experts will be there to guide you through offering you unique perspectives based on their own risk styles.  This way you can learn how each feels right to you. 
<br><br>
       <!-- Card Container -->
       <div class="card-container">
          <!-- Individual Cards -->
          <div class="card">
            <img src="https://assets.codepen.io/11151897/bengraham1.png" alt="StingyCat - The Cautious Observer" />
            <div class="card-title">StingyCat - The Cautious Observer  (Inspired by Benjamin Graham)
              </div>Risk Philosophy: StingyCat, the cautious and prudent elder, teaches us that understanding and managing risk is about knowing what lies beneath the surface. He believes in the power of knowledge and analysis to minimize risk always on the hunt to find hidden gems in the financial world.


            
          </div>
<div>
          <div class="card">
            <img src="https://assets.codepen.io/11151897/macromeow.png" alt="MacroMeow - The Global Thinker" />
            <div class="card-title">MacroMeow - The Global Thinker (Inspired by Paul Tudor Jones)</div>Risk Philosophy: MacroMeow, the worldly wanderer, sees risk in the patterns of global events. He's the cat who understands that risk is not just in the details but in the big picture, connecting distant dots to navigate through economic jungles.
          </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/quantcat4.png" alt="QuantCat - The Analytical Mind" />
            <div class="card-title">QuantCat - The Analytical Mind (Inspired by Jim Simons)</div>Risk Philosophy: In QuantCat's analytical eyes, risk is a puzzle to be solved with data and algorithms. He approaches risk with a logical and calculated mindset, trusting in the patterns and probabilities uncovered by his meticulous research.
          </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/pookerpaws.png" alt="PokerPaws - The Calculated Risk-Taker" />
            <div class="card-title">PokerPaws - The Calculated Risk-Taker (Inspired by Steve Cohen)</div>
            Risk Philosophy: PokerPaws knows that life is a game of calculated risks. He sees risk as an integral part of decision-making, where understanding and managing your own tolerance and the odds can lead to great rewards.
          </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/derivitails3.png" alt="DeriviTails - The Unpredictable Strategist" />
            <div class="card-title">DeriviTails - The Unpredictable Strategist (Inspired by Nassim Nicholas Taleb)</div>Risk Philosophy: DeriviTails, the vigilant guardian, reminds us that the most significant risks are often the ones we least expect. He focuses on preparing for the unforeseen and finding opportunity in uncertainty.
          </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/techtrendtabby.png" alt="TrailblazerTabby - The Pioneer" />
            <div class="card-title">TrailblazerTabby - The Pioneer (Inspired by Muriel Siebert)</div>Risk Philosophy: TrailblazerTabby, the pioneering spirit, sees risk as a challenge to be embraced. She believes in breaking barriers and empowering through knowledge, showing that managing risk is not just about financial gain but also about making impactful changes.
          </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/warrenbuffet.png" alt="Warm N. Fluffy - The Patient Investor" />
            <div class="card-title">Warm N. Fluffy - The Patient Investor (Inspired by Warren Buffett)</div>Risk Philosophy: Warm N. Fluffy, the wise and patient sage, teaches that true risk lies in impatience and ignorance. He advocates for a long-term view, where understanding and trust in one's investments lead to secure and steady gains.
          </div>
        </div>

          <div class="card">
            <img src="https://assets.codepen.io/11151897/muezza.png" alt="Muezza - Your Islamic Finance Guide" />
            <div class="card-title">Muezza - Your Islamic Finance Guide</div>Risk Philosophy: Through tools like the Zakat calculator, Muezza empowers Muslims to fulfill their financial obligations while adhering to their faith's teachings, ensuring that risk is balanced with righteousness in every investment and financial choice.
          </div>
        </div>
        <br>RiskyPaws invites you to embrace your financial personality, understanding that risk management is not just a skill, but a journey of self-discovery. From work to wealth, debt to investments, knowing your tolerance and approach to risk can illuminate pathways you never thought possible. Join us in this adventure of wisdom, courage, and a dash of feline intuition, and let's navigate the financial world with confidence and a purr.
      </div>
    </div><br><br><br><br><br><br>
</template>


<script>

</script>

<style scoped>
.container {
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
}
.stingycat-button {
  background-color: black; /* Black */
  border: none;
  border-radius: 50px;  /* Fully rounded corners */
  color: white;  /* Text color */
  font-size: 1.2em;
  padding: 12px 24px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.stingycat-button:hover {
  background-color: #FF9800;  /* Orange */
}

.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 20px;
  }

  .card {
    background-color: #f0f0f0;
    border-radius: 10px;
    text-align: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .card img {
    width: 100%;
    border-radius: 10px;
  }

  .card-title {
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }
</style>